<template>
  <div class="member-server" style="margin-top:0px;">
    <h1 class="member-title member-title2 text-left">操作助手</h1>
    <el-row class="member-tools">
      <el-col :span="8" class="share enable" @click.native="menuClick(1)">分享简历</el-col>
      <el-col v-if="jobId <= 0 && type < 3" :span="8" class="chatUser enable" @click.native="menuClick(2)">立即沟通</el-col>
      <el-col v-if="jobId <= 0 && type > 2" :span="8" class="chatUser enable" @click.native="menuClick(3)">帮我约</el-col>
      <el-col v-if="jobId > 0 && recommendInfo.recommendState == 1" :span="8" class="passed enable"
        @click.native="menuClick(4)">符合要求</el-col>
      <el-col v-if="jobId > 0 && recommendInfo.recommendState == 1" :span="8" class="refuse enable"
        @click.native="menuClick(5)">不合适</el-col>
    </el-row>
    <div v-if="recommendInfo.recommendState != 1" style="height: 12px;"></div>
    <div v-if="jobId > 0" class="recommend-info">
      <div>{{$Shared.formatDateTime3(recommendInfo.recommendTime)}}</div>
      <div><span v-if="recommendInfo.isSystem == 0">顾问「{{recommendInfo.gwName}}」</span><span
          v-else>由系统</span>推荐到职位：{{recommendInfo.postName}}</div>
      <div v-if="recommendInfo.recommendState != 1" style="margin-top: 12px;">
        {{$Shared.formatDateTime3(recommendInfo.recommendTime)}} 设置为 「{{recommendInfo.recommendStateText}}」</div>
    </div>
    <el-dialog title="分享简历" width="30%" :visible.sync="shareShow">
      <el-input v-model="shareEmail" placeholder="请输入接收简历的邮箱"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shareShow = false">取 消</el-button>
        <el-button type="primary" @click="onConfirmShare">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
  import {
    lastRecommendInfo,
    setRecommendPass,
    setRecommendRefuse,
    shareToEmail
  } from '~/api/referral';
  export default {
    props: {
      type: {
        type: Number,
        default: 1
      }, //1-乐跳可推荐，2-乐跳历史会员，3-乐跳游客 4-猎头候选人，5-O库人才(Ma...)，6-P1库人才(Mb...)
      isDL: {
        type: Boolean,
        default: false
      }, //是否已下载
      resumeId: {
        type: Number,
        default: 0,
      },
      jobId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        recommendInfo: {},
        shareShow: false,
        shareEmail: '',
      };
    },
    computed: {},
    created() {
      if (this.resumeId > 0 && this.jobId > 0) {
        this.getRecommendInfo();
      }
    },
    methods: {
      getRecommendInfo() {
        var params = {
          resumeId: this.resumeId,
          jobId: this.jobId
        };
        lastRecommendInfo(params).then(r => {
          if (r.errcode === 0) {
            this.recommendInfo = r.data;
          }
        });
      },
      menuClick(itemId) {
        switch (itemId) {
        case 1:
          this.shareShow = true;
          break;
        case 4:
          this.onPass();
          break;
        case 5:
          this.onRefuse();
          break;
        default:
          this.$emit('menu-click', itemId);
          break;
        }
      },
      onPass() {
        this.$confirm('该简历符合要求，和人才聊聊？', '符合要求').then(() => {
          var params = {
            resumeId: this.resumeId,
            jobId: this.jobId
          };
          setRecommendPass(params).then(r => {
            if (r.errcode === 0) {
              this.getRecommendInfo();
              this.$emit('menu-click', 4);
            }
          });
        }).catch(() => {});
      },
      onRefuse() {
        this.$confirm('确定该简历不符合要求？', '不合适').then(() => {
          var params = {
            resumeId: this.resumeId,
            jobId: this.jobId
          };
          setRecommendRefuse(params).then(r => {
            if (r.errcode === 0) {
              this.$message.success('设置成功。');
              this.getRecommendInfo();
            }
          });
        }).catch(() => {});
      },
      onConfirmShare() {
        if (!this.shareEmail) {
          this.$message.error('请输入邮箱地址');
          return false;
        }
        if (!this.$Shared.isEmail(this.shareEmail)) {
          this.$message.error('请输入正确的邮箱地址');
          return false;
        }
        var params = {
          resumeId: this.resumeId,
          resumeType: this.type,
          email: this.shareEmail
        };
        shareToEmail(params).then(m => {
          if (m.errcode == 0) {
            this.$message.success('发送成功，请注意查收（如未收到，请检查下垃圾箱）');
          } else {
            this.$message.error('发送失败, ' + m.errmsg);
          }
        });
      },
    }
  };
</script>

<style scoped>
  .recommend-info {
    font-size: 13px;
    color: rgb(153, 153, 153);
    padding: 0 20px 20px;
    line-height: 20px;
  }
</style>